import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../logo.png";
import passwordRevealed from "../assets/password_revealed.png";
import passwordNotRevealed from "../assets/password_not_revealed.png";

const iconStyle = { width: 24, height: 24, verticalAlign: "middle" };

const Login = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      console.log("LOGIN SUBMIT:", form.email, form.password);
      const apiUrl = process.env.REACT_APP_API_URL || "";
      const res = await fetch(`${apiUrl.replace(/\/$/, "")}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Login failed");
      // MFA gate: expect mfaRequired flow; navigate to correct MFA route
      if (data.mfaRequired) {
        // Keep small pieces in localStorage to survive refresh
        localStorage.setItem("mfa_email", data.email || form.email);
        localStorage.setItem("mfa_session", data.sessionId);
        localStorage.setItem("mfa_totpSetup", data.totpSetup ? "1" : "0");
        const method = data.method || "totp";
        localStorage.setItem("mfa_method", method);
        if (method === "sms") {
          navigate("/mfa-sms", {
            state: {
              email: data.email || form.email,
              sessionId: data.sessionId,
            },
          });
        } else {
          navigate("/mfa", {
            state: {
              email: data.email || form.email,
              sessionId: data.sessionId,
              totpSetup: data.totpSetup,
            },
          });
        }
        return;
      }
      // Legacy/direct token (if backend returns token directly)
      if (data.token) {
        localStorage.setItem("token", data.token);
        navigate("/students");
        return;
      }
      throw new Error("Unexpected login response");
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: 32,
          marginBottom: 32,
        }}
      >
        <img
          src={logo}
          alt="Counselor Notes Logo"
          style={{ width: 400, maxWidth: "90vw" }}
        />
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          width: 320,
        }}
      >
        <h1 style={{ textAlign: "center" }}>Login</h1>
        <form
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 20,
            marginTop: 32,
          }}
          onSubmit={handleSubmit}
        >
          <input
            name="email"
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            style={{
              padding: 12,
              fontSize: 16,
              borderRadius: 4,
              border: "1px solid #ccc",
            }}
            required
          />
          <div style={{ position: "relative" }}>
            <input
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              style={{
                padding: 12,
                fontSize: 16,
                borderRadius: 4,
                border: "1px solid #ccc",
                width: "92%",
              }}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword((v) => !v)}
              style={{
                position: "absolute",
                right: 8,
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
                width: 32,
                height: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={showPassword ? passwordRevealed : passwordNotRevealed}
                alt={showPassword ? "Hide password" : "Show password"}
                style={iconStyle}
              />
            </button>
          </div>
          <button
            type="submit"
            disabled={submitting}
            style={{
              width: "100%",
              padding: "16px 0",
              fontSize: 20,
              background: "#2563eb",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              transition: "background 0.2s",
            }}
          >
            {submitting ? "Logging in..." : "Login"}
          </button>
        </form>
        {error && <div style={{ color: "red", marginTop: 16 }}>{error}</div>}
        <div
          style={{
            marginTop: 24,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <div>
            Don't have an account? <Link to="/signup">Sign up</Link>
          </div>
          <div>
            <Link
              to="/forgot-password"
              style={{
                display: "inline-block",
                padding: "10px 14px",
                borderRadius: 6,
                border: "1px solid #2563eb",
                color: "#2563eb",
                textDecoration: "none",
                fontWeight: 600,
              }}
            >
              Forgot password?
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
